<template>
  <ul class="pagination columns is-gapless is-mobile">
    <li class="column">
      <a
      v-no-select
      class="pagination-previous pagination-link"
      :class="{ 'is-disabled': page === 1 }"
      @click="prevPage()">
        <i class="keyboard_arrow_left"></i>
      </a>
    </li>
    <li  class="column" v-for="n in items">
      <a 
      v-no-select
      @click="handlePageSelected(n)"
      :class="{
        'is-current': n === page,
        'pagination-link': !isNaN(n)
      }"
      v-html="n">
      </a>
    </li>
    <li class="column">
      <a
      v-no-select
      class="pagination-next pagination-link"
      :class="{ 'is-disabled': page === pageCount }"
      @click="nextPage()">
        <i class="keyboard_arrow_right"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 0
    },
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    items: function () {
      if (this.pageCount <= 5) {
        return this.range(1, this.pageCount)
      }

      let min = this.page - 3
      min = min > 0 ? min : 1

      let max = min + 6
      max = max <= this.pageCount ? max : this.pageCount

      if (max === this.pageCount) {
        min = this.pageCount - 6
      }

      let range = this.range(min, max)

      if (this.page >= 4 && this.pageCount > 6) {
        range.splice(0, 2, 1, '&hellip;')
      }

      if (this.page + 3 < this.pageCount && this.pageCount > 6) {
        range.splice(range.length - 2, 2, '&hellip;', this.pageCount)
      }

      return range
    }
  },
  methods: {
    range (from, to) {
      let range = []

      from = from > 0 ? from : 1

      for (let i = from; i <= to; i++) {
        range.push(i)
      }

      return range
    },
    handlePageSelected: function (selected) {
      this.$emit('change', selected)
    },
    prevPage: function () {
      if (this.page <= 0) return

      this.$emit('change', this.page - 1)
    },
    nextPage: function () {
      if (this.page >= this.pageCount) return

      this.$emit('change', this.page + 1)
    },
    firstPageSelected: function () {
      return this.page === 0
    },
    lastPageSelected: function () {
      return (this.page === this.pageCount - 1) || (this.pageCount === 0)
    }
  },
  mounted: function () {
    // this.selected = this.page
  }
}
</script>

<style>
.pagination {
  margin: 0;
  padding: 0.25rem 0;
  max-width: 100%;
  width: 25rem;
}

.pagination > li {
    padding: 0 .15em;
    max-width: 11%;
}

.pagination > li > a {
  color: #fff;
  padding: 0;
  margin: 0;
  min-height: 2.4rem;
  font-weight: 500;
  font-size: 2rem;
  -webkit-transform: scale(.8);
  transform: scale(.8);
  border: 0;
  height: 2rem;
  width: 100%;
  margin: auto;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: transparent;
  text-decoration: none;
  border-radius: 4px;
  pointer-events: none;
}

.pagination > li > a.pagination-link {
  cursor: pointer;
  font-size: 1rem;
  color: #000;
  background: #f4f4f4 !important;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
  pointer-events: all;
  transition: .2s ease-out;
}

.pagination > li > a.pagination-link.pagination-previous,
.pagination > li > a.pagination-link.pagination-next,
.pagination > li > a.pagination-link.is-current {
  font-weight: 700;
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
}

.pagination > li > a.pagination-link.is-disabled {
  opacity: .6;
  pointer-events: none;
}
</style>
